/* Draft: requires the matching read-only Worker status endpoint. */
(function (root) {
  function createChecker(endpoint, request, now) {
    now = now || Date.now;
    var cache = {};
    return function (prize, changed) {
      if (!prize || !prize.statusToken || !endpoint) return false;
      if (prize.expiresAt && !(Date.parse(prize.expiresAt) > now())) return false;
      var key = prize.statusToken, entry = cache[key];
      if (entry && entry.until > now()) return entry.eligible === true;
      if (entry && entry.pending) return false;
      entry = cache[key] = { pending: true, eligible: false, until: 0 };
      var controller = new AbortController(), timeout;
      var work = Promise.resolve().then(function () { return request(endpoint.replace(/\/$/, '') + '/lotto/status', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: key }), signal: controller.signal,
        credentials: 'omit', cache: 'no-store'
      }); }).then(function (response) {
        if (!response.ok) throw new Error('unavailable');
        return response.json();
      });
      Promise.race([work, new Promise(function (_, reject) {
        timeout = setTimeout(function () { controller.abort(); reject(new Error('timeout')); }, 5000);
      })]).then(function (data) {
        entry.eligible = data.eligible === true;
      }).catch(function () { entry.eligible = false; }).finally(function () {
        clearTimeout(timeout); entry.pending = false; entry.until = now() + 15000;
        changed();
      });
      return false;
    };
  }
  if (typeof module === 'object' && module.exports) module.exports = createChecker;
  else root.NonLottoPrizeStatus = createChecker;
})(typeof window !== 'undefined' ? window : this);
